define('SageDotCom/Utility/dimensions',[], function () {

  var dimensions = {},
      timeout = false,
      delay = 250;

  // window.resize event listener
  window.addEventListener('resize', function () {
    clearTimeout(timeout);
    timeout = setTimeout(getDimensions, delay);
  });

  var getDimensions = function getDimensions() {
    dimensions.height = window.innerHeight;
    dimensions.width = window.innerWidth;
    return dimensions;
  };

  return getDimensions();
});

